import { Dataset, DEFAULT_PAGE_SIZE, DtFilter, DtSort } from '@/components/data-table/helpers';
import { GroupModel } from '../models/group.model';
import { JsonObject, UiOption } from '../helpers';
import { CreateResponse, DeleteResponse, ListResponse, PatchResponse, SAFE_LIMIT } from '.';
import { post, get, patch, create, deleteApi } from './sp-api.service';

type SearchFilter = {
  keyword?: string;
};

// @todo need to increase limit
export const getAllGroups = async () => (await getGroups(0, SAFE_LIMIT)).rows;

export const getGroups = async (
  page = 0,
  pageSize = DEFAULT_PAGE_SIZE,
  dtSort: DtSort = { columnName: 'name', direction: 'asc' },
  dtFilter?: DtFilter
): Promise<Dataset<GroupModel>> => {
  const { keyword } = dtFilter || {};

  const filterParams: SearchFilter = {};

  if (keyword) {
    filterParams.keyword = keyword;
  }

  const { data, count } = (await post('/group/search', {
    page: page + 1,
    pageSize,
    count: true,
    match: filterParams,
    sort: [{ [dtSort.columnName]: dtSort.direction }],
  })) as ListResponse;

  const rows: GroupModel[] = data.map((doc) => new GroupModel(doc));

  return {
    page,
    pageSize,
    rows,
    total: count,
  };
};

// @todo pending list endpoint match update
export const getNonSyncGroupOptions = async (): Promise<UiOption[]> => {
  const { data } = (await post('/group/search', {
    page: 1,
    pageSize: SAFE_LIMIT,
    count: false,
    match: { includeSynced: false },
  })) as ListResponse;

  if (!data) {
    return [];
  }

  return data.map(({ _id, name }) => ({ value: _id as string, label: name as string }));
};

export const getGroupById = async (groupId: string): Promise<GroupModel | null> => {
  const response = await get(`/group/${groupId}`);
  return response ? new GroupModel(response as JsonObject) : null;
};

export const patchGroup = async (group: GroupModel): Promise<PatchResponse> => {
  const { id, name, description } = group;
  return patch(`/group/${id}`, { name, description });
};

export const createGroup = async (group: GroupModel): Promise<CreateResponse> => {
  const { name, description } = group;

  const response = await create('/group', { name, description });

  if (!response.created) {
    return response;
  }

  response.model = new GroupModel(response.data);

  return response;
};

export const deleteGroup = async (groupId: string): Promise<DeleteResponse> => {
  return deleteApi(`/group/${groupId}`);
};
